import * as React from "react";

interface Props {
    color: string;
}

export const ReviewOnboardingIcon = React.forwardRef<SVGSVGElement, Props>(
    (props, ref): JSX.Element => (
        <svg ref={ref} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.0013" cy="16.0003" r="7.70833" stroke={props.color} strokeWidth="1.25" />
            <path
                d="M16.8346 11.8333C16.8346 12.2936 16.4615 12.6667 16.0013 12.6667C15.5411 12.6667 15.168 12.2936 15.168 11.8333C15.168 11.3731 15.5411 11 16.0013 11C16.4615 11 16.8346 11.3731 16.8346 11.8333Z"
                fill={props.color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0013 14.3333C16.4615 14.3333 16.8346 14.7064 16.8346 15.1667V20.1667C16.8346 20.6269 16.4615 21 16.0013 21C15.5411 21 15.168 20.6269 15.168 20.1667V15.1667C15.168 14.7064 15.5411 14.3333 16.0013 14.3333Z"
                fill={props.color}
            />
        </svg>
    )
);
